import { Injectable } from "@angular/core";

@Injectable({
    providedIn: "root"
})
export class PiSettingFilter {
    includes = [];
    excludes = [];
    list = [];
    participatingInsurerSettings = null;

    public start(list) {
        this.includes = [];
        this.excludes = [];
        this.list = list;

        return this;
    }

    public input(participatingInsurerSettings) {
        this.participatingInsurerSettings = participatingInsurerSettings;

        return this;
    }

    public filter() {
        if (this.participatingInsurerSettings == null ||
            this.participatingInsurerSettings.customParticipatingInsurerFieldList.length === 0) {
            return this;
        }

        this.list.forEach(entry => {
            const found = this.participatingInsurerSettings.customParticipatingInsurerFieldList.find(name => {
                return name == entry.Name;
            });

            if (!found) {
                this.excludes.push(entry);
            }
        });

        return this;
    }

    public exclude() {
        return Array.from(this.excludes);
    }

    public include() {
        return Array.from(this.includes);
    }
}
